import { SkeletonTableContent } from 'modules/campaignsSentMessagesLogs/components';
import { CellAlignTypes } from 'modules/experiments/types';
import { SpamReport } from 'modules/templateEditor/hooks/useGetSpamReportQuery';
import { ReactElement, memo } from 'react';
import { Table } from 'ui/table';
import { TableCell } from 'ui/tableCell';
import { ColumnData, TableHeader } from 'ui/tableHeader';
import { TableRows, TableRowsColumn } from 'ui/tableRows';
import { SpamReportClassificationLabel } from './SpamReportClassificationLabel';

export interface SpamReportTableColumnData extends TableRowsColumn, ColumnData {
  RowCell: ({ row }: { row: SpamReport }) => ReactElement;
}

export const tableColumnsConfig: SpamReportTableColumnData[] = [
  {
    align: CellAlignTypes.flexStart,
    name: 'Spam filter',
    value: 'filter',
    sortable: false,
    RowCell: ({ row }) => <TableCell>{row.filter}</TableCell>,
  },
  {
    name: 'Filter type',
    value: 'typeOfFilter',
    align: CellAlignTypes.flexStart,
    sortable: false,
    RowCell: ({ row }) => <TableCell>{row.typeOfFilter}</TableCell>,
  },
  {
    name: 'Status',
    value: 'classification',
    align: CellAlignTypes.flexStart,
    sortable: false,
    RowCell: ({ row }) => (
      <TableCell>
        <SpamReportClassificationLabel classification={row.classification} />
      </TableCell>
    ),
  },
];

interface SpamReportTableProps {
  isLoading: boolean;
  data: SpamReport[] | undefined;
}

export const SpamReportTable = memo(({ isLoading, data }: SpamReportTableProps) => {
  if (!isLoading && !data?.length) {
    return null;
  }

  const tableRows = data?.map((row, i) => ({ ...row, id: `${row.filter}-${i}` })) || [];

  return (
    <Table>
      {isLoading ? (
        <SkeletonTableContent
          numRows={11}
          tableColumnsConfig={tableColumnsConfig}
          cellHeight={20}
          cellWidth={150}
        />
      ) : (
        <>
          <TableHeader columns={tableColumnsConfig} />
          <TableRows rows={tableRows} columns={tableColumnsConfig} />
        </>
      )}
    </Table>
  );
});
